/**
 * パスワード用正規表現（使用可能文字・文字数チェック）
 * - 文字数：7〜15文字
 * - 使用可能文字：
 *   - 半角英字（大文字・小文字）
 *   - 数字
 *   - 許容記号：! @ # $ % ^ & * ( ) - _ = +
 */
const PASSWORD_REGEXP = /^[A-Za-z0-9!@#$%^&*()\-_=+]{7,15}$/;

/**
 * パスワードのバリデーション関数（店舗・スタッフ共通）
 *
 * 1. 使用可能文字と文字数をチェック
 * 2. 各文字種の存在チェック（大文字・小文字・数字・記号）
 * 3. 文字種の数をカウント
 * 4. 2種類以上の文字種があれば有効と判断
 *
 * @param password - バリデーション対象のパスワード文字列
 * @returns true: ルールを満たす, false: ルールを満たさない
 */
export const validatePassword = (password: string) => {
  if (!PASSWORD_REGEXP.test(password)) return false;

  const hasUpper = /[A-Z]/.test(password);
  const hasLower = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSymbol = /[!@#$%^&*()\-_+=]/.test(password);

  const typesCount = [hasUpper, hasLower, hasNumber, hasSymbol].filter(Boolean).length;

  return typesCount >= 2;
};